"use client";

import { useTranslations } from "next-intl";
import PhoneInput from "react-phone-number-input";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

// Ordre voulu : Appel téléphonique → Google Meet vocal → Google Meet vidéo.
// Les clés (phone/voice/video) sont celles stockées en base : ne pas renommer.
export const MEETING_PREFERENCES = [
    {
        key: "phone",
        icon: "phone-rounded-linear",
        label: "GuestBooking_pref_phone",
        description: "GuestBooking_pref_phone_desc",
    },
    {
        key: "voice",
        icon: "microphone-linear",
        label: "GuestBooking_pref_voice",
        description: "GuestBooking_pref_voice_desc",
    },
    {
        key: "video",
        icon: "videocamera-record-linear",
        label: "GuestBooking_pref_video",
        description: "GuestBooking_pref_video_desc",
    },
];

export default function MeetingPreferenceSelector({
    value,
    onChange,
    phoneNumber,
    onPhoneChange,
}) {
    const t = useTranslations();

    return (
        <div className="flex flex-col gap-2">
            {MEETING_PREFERENCES.map((pref) => {
                const active = value === pref.key;
                return (
                    <div key={pref.key}>
                        <button
                            type="button"
                            onClick={() => onChange(pref.key)}
                            className={`w-full flex items-center gap-3 rounded-xl border px-3.5 py-3 text-left transition ${
                                active
                                    ? "border-primary ring-1 ring-primary bg-primary/[0.04]"
                                    : "border-gray-200 dark:border-borderDark hover:border-gray-300 dark:hover:border-grayDark-500"
                            }`}
                        >
                            <span
                                className={`flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center transition-colors ${
                                    active
                                        ? "bg-primary/10 text-primary"
                                        : "bg-gray-100 dark:bg-bgDark-900 text-gray-500 dark:text-grayDark-400"
                                }`}
                            >
                                <SolarIcon name={pref.icon} className="text-lg" />
                            </span>
                            <span className="min-w-0 flex-1">
                                <span className="block text-sm font-semibold text-gray-900 dark:text-white">
                                    {t(pref.label)}
                                </span>
                                <span className="block text-xs text-gray-500 dark:text-grayDark-400 mt-0.5 leading-snug">
                                    {t(pref.description)}
                                </span>
                            </span>
                            <span
                                className={`flex-shrink-0 w-5 h-5 rounded-full border flex items-center justify-center transition-colors ${
                                    active
                                        ? "border-primary"
                                        : "border-gray-300 dark:border-grayDark-600"
                                }`}
                            >
                                {active && (
                                    <span className="w-2 h-2 rounded-full bg-primary" />
                                )}
                            </span>
                        </button>
                        {pref.key === "phone" && active && (
                            <PhoneInput
                                international
                                defaultCountry="FR"
                                className="phone-input-field mt-2"
                                placeholder={t("GuestBooking_phone_placeholder")}
                                value={phoneNumber}
                                onChange={(val) => onPhoneChange(val || "")}
                                autoFocus
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
}
